<template>
    <portal to="modals">
        <Modal name="broken-parts" @closed="$emit('closed')">
            <template #content>
                <div class="book-export__empty">
                    <p>
                        <b style="color: #ff4141">{{ $t('export.repair.title') }}</b>
                    </p>
                    {{ $t('export.repair.forExample') }}:
                    <ol>
                        <template v-if="parts.length < 5">
                            <li v-for="part in parts" :key="part.pk">
                                <span>
                                    {{ part.raw_text }}
                                </span>
                            </li>
                        </template>
                        <template v-else>
                            <li v-for="i in 5" :key="i">
                                <span>
                                    {{ parts[i - 1].raw_text }}
                                </span>
                            </li>
                        </template>
                    </ol>
                    <p>
                        <span style="margin-right: 10px">
                            {{ $t('export.repair.total', parts.length) }}
                        </span>
                        <a
                            v-if="!noRedirect"
                            href="#"
                            class="link"
                            style="margin-right: 15px"
                            @click.prevent="openBrokenInEditor"
                        >
                            {{ $t('export.repair.openInEditor') }}
                        </a>
                        <a
                            v-if="!sentToSupport"
                            href="#"
                            class="link"
                            @click.prevent="sendpartsToSupport"
                        >
                            {{ $t('support.send') }}
                        </a>
                        <span v-else style="color: #1ba60f">
                            {{ $t('support.success') }}
                            <a href="mailto:hello@speechki.org" class="link">hello@speechki.org</a>
                        </span>
                    </p>
                    <template v-if="confirmable">
                        <div
                            v-t="$t('export.repair.notice')"
                            class="book-export__notice"
                            style="font-size: 14px"
                        ></div>
                        <div class="modal__confirm">
                            <button
                                type="button"
                                class="button modal__confirm-button"
                                @click.prevent="confirmExport"
                            >
                                {{ $t('export.repair.export') }}
                            </button>
                            <button
                                type="button"
                                class="button button--gray modal__confirm-button"
                                @click.prevent="closeModal"
                            >
                                {{ $t('confirmModal.cancel') }}
                            </button>
                        </div>
                    </template>
                </div>
            </template>
        </Modal>
    </portal>
</template>

<script>
import { Modal } from '@speechki-frontend/shared/ui/modals';
import { sendMessageToSupport } from '@speechki-frontend/core/misc/api/support';

export default {
    name: 'PartsModal',
    components: {
        Modal,
    },
    props: {
        parts: {
            type: Array,
            required: true,
        },
        book: {
            type: Object,
            required: true,
        },
        confirmable: {
            type: Boolean,
            default: true,
        },
        noRedirect: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            sentToSupport: false,
        };
    },
    methods: {
        confirmExport() {
            this.$emit('confirm');
        },
        async sendpartsToSupport() {
            try {
                this.sentToSupport = true;
                const data = {
                    text: 'Пустые аудио в книге',
                    params: { book: this.book, parts: this.parts },
                };
                await sendMessageToSupport(data);
            } catch (error) {
                console.log(error);
            }
        },
        openBrokenInEditor() {
            this.closeModal();
            this.$emit('openBrokenEditor');
        },
        closeModal() {
            this.$emit('closed');
        },
    },
};
</script>
